module.exports = __webpack_public_path__ + "img/14ry_tp05.525e6cfa.gif";